module.exports = __webpack_public_path__ + "static/media/loading-gif.8b9a5cd1.gif";